import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~commonInfra/utils/ConnectUtils';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { enterSpace } from '../../../actions/EnterSpaceAction';

export interface SpaceInfoProviderOwnProps {
  readonly spaceInfo: SpaceInfo;
}

export interface SpaceInfoProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

export type SpaceInfoProviderProps = SpaceInfoProviderOwnProps & SpaceInfoProviderDispatchProps;

export class SpaceInfoProvider extends React.PureComponent<SpaceInfoProviderProps> {
  constructor(props: SpaceInfoProviderProps) {
    super(props);
    props.enterSpace(props.spaceInfo);
  }

  render() {
    return <>{this.props.children}</>;
  }
}

const mapDispatchToProps: MapDispatchToProps<SpaceInfoProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
}, dispatch);

export const ConnectedSpaceInfoProvider: React.ComponentClass<SpaceInfoProviderOwnProps>
  = connect(null, mapDispatchToProps)(SpaceInfoProvider);

/**
 * Creates a higher order component that wraps the given component with the SpaceInfoProvider component.
 */
export function withSpaceInfoProvider<P>(Component: React.ComponentType<P>) {
  return (props: P & SpaceInfoProviderProps) => (
    <ConnectedSpaceInfoProvider {...props}><Component {...props}/></ConnectedSpaceInfoProvider>
  );
}
